import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import ReactLoading from 'react-loading';
import styledCmp from 'styled-components';

export const Load = styledCmp(ReactLoading).attrs((props) => ({
  type: 'spin',
  color:
    props.theme.palette[
      props.theme.palette[props?.color] ? props?.color : 'primary'
    ]?.[props.outline ? 'main' : 'contrastText'],
  height: 'auto',
  width: 20,
}))`
`;

// font - family: Kumbh Sans;
// font - size: 16px;
// font - weight: 500;
// line - height: 19.84px;
// text - align: center;
// text - underline - position: from - font;
// text - decoration - skip - ink: none;

const BaseButton = styled(Button)(
  ({ theme, between, start, border, width, radius, outline, safeColor }) => ({
    width: width ? width : '100%',
    textTransform: 'none',
    display: 'flex',
    justifyContent: between ? 'space-between' : start ? 'flex-start' : 'center',
    boxShadow: 'none',
    whiteSpace: 'nowrap',
    fontFamily: 'Kumbh Sans',
    fontWeight: '500',
    borderRadius: radius && radius,
    border: border || (outline && '1px solid'),
    borderColor: outline ? safeColor : theme.palette.colors.shadow,
    transition: 'all 0.2s ease-in-out',
    fontSize: '16px',
    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
      opacity: 0.7,
    },
  })
);

export const ColorButton = styled(BaseButton)(({ small, fontSize, style }) => ({
  minHeight: small ? 40 : 48,
  marginTop: small ? '0px' : '16px',
  padding: small ? '4px 12px' : '12px 24px',
  fontSize: fontSize ?? '16px',
  ...style,
}));

export const GradientButton = styled(BaseButton)(
  ({ theme, small, fontSize, style }) => ({
    minHeight: small ? 40 : 48,
    marginTop: small ? '0px' : '16px',
    padding: small ? '4px 12px' : '12px 24px',
    background: theme.palette.gradient.primary,
    color: '#white',
    '&.Mui-disabled': {
      background: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
      opacity: 0.6,
      border: 'none',
    },
    fontSize: fontSize ?? '16px',
    ...style,
  })
);

export const Mbutton = styled(BaseButton)(({ small, style }) => ({
  minHeight: small ? 12 : 20,
  marginTop: small ? '0px' : '16px',
  padding: small ? '2px 12px' : '12px 24px',
  fontSize: '14px',
}));
